export const key = "global-preferences.edit";
